import { render, staticRenderFns } from "./TabelaPrecoListFilters.vue?vue&type=template&id=6c169986&"
import script from "./TabelaPrecoListFilters.vue?vue&type=script&lang=js&"
export * from "./TabelaPrecoListFilters.vue?vue&type=script&lang=js&"
import style0 from "./TabelaPrecoListFilters.vue?vue&type=style&index=0&id=6c169986&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports